import cssUtil from 'gw-portals-util-js/CssUtil';
import template from 'text!./ResetPassword.html';
import styles from './ResetPassword-hashed.scss';
import AuthComponentUtils from '../common/AuthComponentUtils';
import AuthenticationService from 'plugin?auth-type!gw-portals-auth-js/AuthenticationService';

// VARS
var hashedTemplate = cssUtil.hashTemplate(template, styles);

// EXPORT

export default {
    template: hashedTemplate,
    controller: ['$scope', '$state', 'oAuth', 'state_plugin_config', function ($scope, $state, oAuth, STATE_PLUGIN_CONFIG) {
        // VARS
        var authenticationService = AuthenticationService(oAuth);
        var $ctrl = this;
        var token = $state.params.token;
        var code = void 0;
        $ctrl.isResetReqInProgress = false; // animation

        // Default model attr required by gw-pl-inline-ctrl-group directive
        $ctrl.newPassword = { aspects: {} };
        $ctrl.confirmPassword = { aspects: {} };

        // METHODS
        var setCtrlParam = AuthComponentUtils.setCtrlParam($ctrl, $scope);

        function setErrorMessage(value) {
            setCtrlParam('errorMessage', value);
        }

        // Validate if token still valid
        authenticationService.verifyResetCode(token).then(function (data) {
            code = data.res;
            setCtrlParam('status', 'RESET_PASSWORD');
        }, function () {
            setCtrlParam('status', 'INVALID_TOKEN');
        });

        $ctrl.changePassword = function () {

            if (!$ctrl.newPassword.value) {
                setErrorMessage('fieldEmpty');
                return;
            }

            if ($ctrl.newPassword.value !== $ctrl.confirmPassword.value) {
                setErrorMessage('fieldsIncorrect');
                return;
            }

            setErrorMessage('');
            setCtrlParam('isRequestInProgress', true);
            authenticationService.changePassword({
                code: code,
                new_password: $ctrl.newPassword.value
            }).then(function (data) {
                authenticationService.login({
                    username: data.result.username,
                    password: $ctrl.newPassword.value
                }).then(function () {
                    // redirect user to home view
                    $state.go(STATE_PLUGIN_CONFIG.home);
                }, function () {
                    setCtrlParam('status', 'AUTO_LOGIN_FAILURE');
                });
            }).catch(function (err) {
                switch (err.error) {
                    case authenticationService.ERRORS.tokens.invalidTokenOrEmail:
                        setCtrlParam('status', 'INVALID_TOKEN_OR_PASSWORD');
                        break;
                    default:
                        setCtrlParam('status', 'INVALID_ATTEMPT');
                        break;
                }
            });
        };

        $ctrl.backToSignIn = function () {
            $state.go('authLogin');
        };
    }]
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-auth-angular/components/ResetPassword/index.js
// module id = 1332
// module chunks = 0